import { commitMutation, graphql } from "react-relay";
import environment from "../Environment";

const mutation = graphql`
	mutation ResetPasswordMutation($input: ResetPasswordInput!) {
		resetPassword(input: $input) {
			ok
		}
	}
`;

// let folderName = "x Empty";

export default (uid, token, password, callback) => {
	const variables = {
		input: {
			uid: uid,
			token: token,
			password: password
		}
	};


	commitMutation(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (response.resetPassword != null) {
				callback();
			} else {
				console.log("Error resetting password!");
			}
		},
		onError: err => console.error(err)
	});
};
